module.exports = __webpack_public_path__ + "media/customizations/fieldslife/back-abb143ba41c1f4becf53ff013e391767.jpg";